import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, FormGroup, Button } from 'react-bootstrap';
import { Bubble, LoaderButton, ContinueLabel, Divider } from 'ctia-ui';
import FormElement from 'components/FormElement';
import { notifyMessages } from 'helpers/NotifyHelper';
import {
  handleInputChange,
  fetchPocs,
  updateRequest,
  cleanPocInfo
} from 'actions/request';
import { submitWizardStep } from 'actions/wizard';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';

class PocSelector extends Component {
  componentDidMount() {
    const { startPreloader, finishPreloader, fetchPocs, user } = this.props;
    startPreloader();
    fetchPocs(user.requestOwnerCompanyId).then(() => {
      finishPreloader();
    });
  }

  validate() {
    const { pocId } = this.props.request;

    return pocId > 0;
  }

  renderPocList() {
    const { pocs } = this.props.request;

    if (!_.isEmpty(pocs)) {
      let pocOptions = _.map(pocs, poc => {
        return {
          title: `${poc.lastname}, ${poc.firstname}`,
          value: Number(poc.id)
        };
      });

      // add `select poc` option to the ending of an option list
      pocOptions.unshift({
        title: '--- Select a POC ---',
        value: 0
      });

      // add `new poc` option to the beginning of an option list
      pocOptions.push({
        title: '--- Add new POC entry ---',
        value: 'new'
      });

      return pocOptions;
    }
    return [];
  }

  renderSelectedPocInfo() {
    const { request } = this.props;
    const { pocId, pocs, tn, modelName, vendor } = request;
    const pocsObj = _.mapKeys(pocs, 'id');

    if (pocId > 0) {
      const { firstname, lastname, phone, email } = pocsObj[pocId];
      const emailData = { tn, email, modelName, vendor};

      return (
        <div>
          <FormElement
            id="selectedName"
            label="POC Name"
            value={`${firstname} ${lastname}`}
          />
          <FormElement 
            id="selectedEmail" 
            label="POC Email" 
            value={emailData} 
            type="emailLink"
          />
          <FormElement id="selectedPhone" label="POC Phone" value={phone} />
        </div>
      );
    }

    return null;
  }

  onSelectPoc = event => {
    if (event.target.value === 'new') {
      // hide selector (callback from parent component)
      this.props.toggleSelector(false);

      // set up as empty value
      event.target.value = '';
    }

    // set poc id for request
    this.props.handleInputChange(event);
  };

  onSaveClick = () => {
    const {
      request,
      updateRequest,
      startPreloader,
      finishPreloader,
      showNotice
    } = this.props;

    startPreloader().then(
      updateRequest({
        id: request.id,
        pocid: request.pocId
      })
        .then(finishPreloader)
        .then(showNotice(notifyMessages.requestUpdatedSuccessfully))
    );
  };

  onNewEntryClick = () => {
    // clean POC data from request
    this.props.cleanPocInfo();

    // toggle selector view and show POC form instead
    this.props.toggleSelector(false);
  };

  render() {
    const { request, submitWizardStep, wizard, show, isNew, user } = this.props;

    if (!show) return null;

    const isEditable = user.canEditRequest;

    if (request.pocs) {
      return (
        <div>
          <Bubble show={isEditable}>
            Please select the <strong>Point of Contact (POC)</strong> for this
            request or{' '}
            <Button
              bsSize="small"
              bsStyle="primary"
              onClick={this.onNewEntryClick}
            >
              Create new entry
            </Button>
          </Bubble>
          <Bubble show={!isEditable}>
            Please select the <strong>Point of Contact (POC)</strong> for this
            request
          </Bubble>
          <Form horizontal>
            <FormElement
              type="select"
              id="pocId"
              label="Point of Contact"
              value={request.pocId}
              onChange={this.onSelectPoc}
              options={this.renderPocList()}
              editable={isEditable}
            />
            {this.renderSelectedPocInfo()}
            <Divider />
            <FormGroup>
              <Col sm={3} />
              <Col sm={4}>
                <LoaderButton
                  bsStyle="default"
                  text="Save changes"
                  disabled={!this.validate()}
                  isLoading={request.isLoading}
                  onClick={this.onSaveClick}
                  show={isEditable && request.id > 0}
                />
              </Col>
              <Col sm={5} className="text-right">
                <LoaderButton
                  bsStyle="info"
                  text={<ContinueLabel />}
                  disabled={!this.validate()}
                  isLoading={request.isLoading}
                  onClick={() => submitWizardStep(wizard)}
                  show={isNew}
                />
              </Col>
            </FormGroup>
          </Form>
        </div>
      );
    } else return null;
  }
}

function mapStateToProps({ request, wizard, user }) {
  return { request, wizard, user };
}

export default connect(
  mapStateToProps,
  {
    handleInputChange,
    submitWizardStep,
    startPreloader,
    finishPreloader,
    fetchPocs,
    updateRequest,
    showNotice,
    cleanPocInfo
  }
)(PocSelector);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/PocSelector.js